import { MS_PER_MINUTE, MS_PER_SECOND } from '@commenda/utils';

export type TCanvasRefreshBadgeConfig = {
  variant: 'blue' | 'warning' | 'gray';
  label: string;
  hasDot: boolean;
};

export class WorkflowCanvasRefreshHelper {
  private static readonly MOMENT_IN_MS = 5 * MS_PER_SECOND;

  static formatLastUpdatedAt(lastUpdatedAt: Date | null): string {
    if (!lastUpdatedAt) return 'Not loaded yet';

    const elapsedMs = Date.now() - lastUpdatedAt.getTime();
    if (elapsedMs < this.MOMENT_IN_MS) return 'Updated a moment ago';
    if (elapsedMs < MS_PER_MINUTE) {
      return `Updated ${Math.round(elapsedMs / MS_PER_SECOND)}s ago`;
    }
    return `Updated ${Math.round(elapsedMs / MS_PER_MINUTE)}m ago`;
  }

  static getRefreshBadgeConfig(
    isRefreshing: boolean,
    isEditInProgress: boolean,
    lastUpdatedAt: Date | null
  ): TCanvasRefreshBadgeConfig {
    if (isRefreshing) {
      return { variant: 'blue', label: 'Updating canvas', hasDot: true };
    }
    if (isEditInProgress) {
      return { variant: 'blue', label: 'Agent is working', hasDot: true };
    }
    return {
      variant: 'gray',
      label: this.formatLastUpdatedAt(lastUpdatedAt),
      hasDot: false,
    };
  }
}
